import { Undo2 } from "lucide-react";
import { toast } from "sonner";
import { useStore, canUndoDelete, undoLastDelete } from "@/lib/store";

// Restores the most recent deletion only; disabled when there is nothing to undo.
export const UndoDeleteButton = ({ variant }) => {
  const can = useStore(canUndoDelete);
  const onClick = () => {
    if (!undoLastDelete()) return;
    toast.dismiss();
    toast.success("Eliminazione annullata");
  };
  if (variant === "tab") {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={!can}
        aria-label="Annulla l'ultima eliminazione"
        className={`flex flex-col items-center justify-center gap-0.5 pt-1.5 pb-1 text-[11px] font-medium transition-colors ${can ? "text-[#B37A87]" : "text-[#B9BFB6]"}`}
        data-testid="undo-delete-tab"
      >
        <span className={`w-14 h-8 rounded-full flex items-center justify-center transition-colors duration-200 ${can ? "bg-[#F4E6E9]" : ""}`}>
          <Undo2 size={20} strokeWidth={1.75} />
        </span>
        Annulla
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!can}
      aria-label="Annulla l'ultima eliminazione"
      title={can ? "Annulla l'ultima eliminazione" : "Niente da annullare"}
      className={`hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium shadow-sm transition-colors ${can ? "bg-white border-[#C48B97] text-[#B37A87] hover:bg-[#F4E6E9]" : "bg-[#FDFDFB] border-[#E4E7E1] text-[#B9BFB6] cursor-not-allowed"}`}
      data-testid="undo-delete-button"
    >
      <Undo2 size={16} strokeWidth={1.75} />
      Annulla eliminazione
    </button>
  );
};
